<template>
  <div class="wrapper">
    <ModalLoading :isLoading="isLoading" />

    <div class="main-container">
      <form
        @submit.prevent="agregarProducto"
        autocomplete="off"
        class="purchase-form"
      >
        <!-- Primera fila: Código y Búsqueda -->
        <div class="form-section search-section">
          <div class="form-group">
            <label for="codigo-busqueda" class="form-label"
              >Código del producto:</label
            >
            <input
              list="codigosList"
              name="codigo-busqueda"
              ref="codigo"
              type="text"
              class="form-input"
              tabindex="1"
              required
              v-model="addQuery"
              placeholder="Ingresar código"
              :disabled="isEditing"
              @input="handleCodigoInput"
            />
            <datalist id="codigosList">
              <option
                v-for="producto in productos"
                :key="producto.id_producto"
                :value="producto.codigo_producto"
              >
                {{ producto.codigo_producto }} - {{ producto.nombre }}
              </option>
            </datalist>
          </div>

          <div class="form-group">
            <label for="referencia" class="form-label"
              >Referencia de Compra:</label
            >
            <input
              type="text"
              id="referencia"
              class="form-input"
              v-model="referenciaPago"
              placeholder="Ingrese referencia de compra"
              maxlength="100"
            />
          </div>

          <div class="form-group search-name">
            <label class="form-label">Buscar por nombre:</label>
            <input
              list="productosList"
              class="form-input"
              :disabled="isEditing"
              v-model="searchQuery"
              placeholder="Ingresar nombre"
              @input="handleSearchInput"
            />
            <datalist id="productosList">
              <option
                v-for="producto in productos"
                :key="producto.id_producto"
                :value="producto.nombre"
              >
                {{ producto.codigo_producto }} - {{ producto.nombre }}
              </option>
            </datalist>
          </div>
        </div>

        <!-- Nueva sección: Datos Fiscales -->
        <div class="form-section fiscal-section">
          <div class="form-group">
            <label for="cai" class="form-label">CAI:</label>
            <input
              type="text"
              id="cai"
              class="form-input"
              v-model="cai"
              placeholder="Ingrese CAI"
              maxlength="50"
            />
          </div>

          <div class="form-group">
            <label for="numero_factura" class="form-label">N° Factura:</label>
            <input
              type="text"
              id="numero_factura"
              class="form-input"
              v-model="numeroFactura"
              placeholder="Ingrese número de factura"
            />
          </div>

          <div class="form-group">
            <label for="tipo_compra" class="form-label">Tipo de Compra:</label>
            <select id="tipo_compra" class="form-input" v-model="tipoCompra">
              <option value="gravado">Gravado 15%</option>
              <option value="exento">Exento</option>
            </select>
          </div>

          <div class="form-group">
            <label for="descuento" class="form-label">Descuento:</label>
            <input
              type="number"
              id="descuento"
              class="form-input"
              v-model="descuento"
              placeholder="0.00"
              step="0.01"
              min="0"
            />
          </div>
        </div>

        <!-- Segunda fila: Cantidades y Precio -->
        <div class="form-section quantities-section">
          <div class="form-group">
            <label for="cantidad" class="form-label">
              Cantidad
              <span v-if="unidadCompraLabel" class="unidad-badge">{{ unidadCompraLabel }}</span>
              <span v-if="!unidadCompraLabel && productoSeleccionado" class="unidad-badge">{{ productoSeleccionado.unidad_medida || 'unid.' }}</span>
              <span v-if="factorConversionInfo" class="factor-hint"> — {{ factorConversionInfo }}</span>
            </label>
            <input
              name="cantidad"
              class="form-input"
              type="number"
              tabindex="3"
              placeholder="Cantidad unitaria"
              v-model="addQuantity"
              min="1"
            />
          </div>

          <div class="form-group">
            <label for="cantidad_paquetes" class="form-label"
              >Cantidad de paquetes:</label
            >
            <input
              name="cantidad_paquetes"
              class="form-input"
              type="number"
              tabindex="4"
              placeholder="Cantidad total de paquetes"
              v-model="addQuantityPackage"
              min="1"
            />
          </div>

          <div class="form-group">
            <label for="total-compra" class="form-label"
              >Precio por paquete:</label
            >
            <input
              name="total-compra"
              class="form-input"
              type="number"
              step="0.01"
              tabindex="5"
              placeholder="Total compra por paquete"
              required
              v-model="addtotalPrice"
              min="0.01"
            />
          </div>

          <div class="form-group button-group">
            <button class="btn btn-primary" type="submit">
              <i class="bi bi-plus-circle-fill"></i> Añadir
            </button>
          </div>
        </div>
      </form>

      <!-- Tabla de Productos -->
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>N.º</th>
              <th>Código</th>
              <th>Nombre</th>
              <th>Paquetes</th>
              <th>Unidad/Paquetes</th>
              <th>Proveedor</th>
              <th>Total Compra</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(producto, index) in productosLista"
              :key="index"
              @click="isEditingTrue(index)"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ producto.codigo }}</td>
              <td>{{ producto.nombre }}</td>
              <td>{{ producto.paquetes }}</td>
              <td>{{ producto.cantidad }}</td>
              <td>{{ producto.proveedor?.nombre || producto.proveedor }}</td>
              <td>{{ producto.total_compra.toFixed(2) }}</td>
              <td class="actions-cell">
                <button class="btn-icon" @click.stop="deleteProducto(index)">
                  <i class="bi bi-x-circle-fill text-danger"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Sección de Resumen Fiscal -->
      <div class="fiscal-summary">
        <div class="summary-row">
          <span class="summary-label">Subtotal:</span>
          <span class="summary-value"
            >L {{ calcularSubtotal.toFixed(2) }}</span
          >
        </div>
        <div class="summary-row" v-if="descuento > 0">
          <span class="summary-label">Descuento:</span>
          <span class="summary-value"
            >L {{ Number(descuento).toFixed(2) }}</span
          >
        </div>
        <div class="summary-row" v-if="tipoCompra === 'gravado'">
          <span class="summary-label">Gravado 15%:</span>
          <span class="summary-value"
            >L {{ calcularGravado15.toFixed(2) }}</span
          >
        </div>
        <div class="summary-row" v-if="tipoCompra === 'exento'">
          <span class="summary-label">Exento:</span>
          <span class="summary-value">L {{ calcularExento.toFixed(2) }}</span>
        </div>
        <div class="summary-row" v-if="tipoCompra === 'gravado'">
          <span class="summary-label">Impuesto 15%:</span>
          <span class="summary-value"
            >L {{ calcularImpuesto15.toFixed(2) }}</span
          >
        </div>
        <div class="summary-row total-row">
          <span class="summary-label">Total Final:</span>
          <span class="summary-value"
            >L {{ calcularTotalFinal.toFixed(2) }}</span
          >
        </div>
      </div>

      <!-- Sección de Totales y Acciones -->
      <div class="footer-section">
        <div class="footer-content">
          <!-- Lado izquierdo - Cancelar -->
          <div class="action-group">
            <div class="shortcut-badge">Esc</div>
            <button class="btn btn-cancel" @click="cancelarCompra">
              <i class="bi bi-x-circle"></i>
              Cancelar compra
            </button>
          </div>

          <!-- Lado derecho - Procesar y Total -->
          <div class="action-group">
            <div class="process-group">
              <div class="shortcut-badge">F12</div>
              <button class="btn btn-process" @click="payModalOpen">
                <i class="bi bi-check-circle"></i>
                Procesar Compra
              </button>
            </div>
            <div class="total-container">
              <span class="total-label">Total</span>
              <div class="total-amount">
                {{ calcularTotalFinal.toFixed(2)
                }}<span class="currency">Lempiras</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Pago -->
    <div class="modal-overlay" v-if="payModal">
      <div class="modal-content">
        <button class="modal-close-x" @click="payModal = false">✕</button>
        <h2>Resumen de Compra</h2>

        <div class="div-modal-resumen">
          <label for="subtotal">Cantidad total Artículos:</label>
          <input type="text" id="subtotal" v-model="articulos_cant" disabled />
        </div>

        <div class="div-modal-resumen">
          <label for="subtotalModal">Subtotal:</label>
          <input
            type="text"
            id="subtotalModal"
            :value="calcularSubtotal.toFixed(2)"
            disabled
          />
        </div>

        <div class="div-modal-resumen" v-if="descuento > 0">
          <label for="descuentoModal">Descuento:</label>
          <input
            type="text"
            id="descuentoModal"
            :value="Number(descuento).toFixed(2)"
            disabled
          />
        </div>

        <div class="div-modal-resumen" v-if="tipoCompra === 'gravado'">
          <label for="gravadoModal">Gravado 15%:</label>
          <input
            type="text"
            id="gravadoModal"
            :value="calcularGravado15.toFixed(2)"
            disabled
          />
        </div>

        <div class="div-modal-resumen" v-if="tipoCompra === 'exento'">
          <label for="exentoModal">Exento:</label>
          <input
            type="text"
            id="exentoModal"
            :value="calcularExento.toFixed(2)"
            disabled
          />
        </div>

        <div class="div-modal-resumen" v-if="tipoCompra === 'gravado'">
          <label for="impuestoModal">Impuesto 15%:</label>
          <input
            type="text"
            id="impuestoModal"
            :value="calcularImpuesto15.toFixed(2)"
            disabled
          />
        </div>

        <div class="div-modal-resumen">
          <label for="totalModal">Total Final:</label>
          <input
            type="text"
            id="totalModal"
            :value="calcularTotalFinal.toFixed(2)"
            disabled
          />
        </div>

        <div class="div-modal-resumen">
          <label class="form-label">Modalidad de Pago:</label>
          <select class="form-input" v-model="modalidadPago">
            <option value="contado">Contado</option>
            <option value="credito">Crédito (Cuenta por Pagar)</option>
          </select>
        </div>

        <div class="div-modal-resumen" v-if="modalidadPago === 'credito'">
          <label class="form-label">Días de crédito:</label>
          <input
            type="number"
            class="form-input"
            v-model.number="diasCredito"
            min="1"
            max="365"
            placeholder="30"
          />
        </div>

        <div class="modal-actions">
          <button class="btn confirmar-pago" @click="confirmPayment">
            {{ modalidadPago === 'credito' ? 'Registrar a Crédito' : 'Confirmar Pago' }}
          </button>
          <button class="btn cancelar" @click="cancelPayment">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- Modal de Confirmación -->
    <div class="modal" v-if="confirmModal">
      <div class="modal-overlay">
        <div class="modal-content">
          <button class="modal-close-x" @click="confirmPaymentClose">✕</button>
          <h2>Compra Realizada</h2>
          <div class="modal-summary"></div>
          <button @click="confirmPaymentClose" class="btn close-btn">
            Cerrar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Cancelación -->
    <div class="modal-overlay" v-if="showConfirmModal">
      <div class="modal-content">
        <button class="modal-close-x" @click="cancelCancel">✕</button>
        <h2>Confirmación</h2>
        <p>¿Estás seguro de que quieres cancelar la compra?</p>
        <div class="modal-actions">
          <button class="btn modalShowConfirm-Si" @click="confirmCancel">
            Sí, cancelar
          </button>
          <button class="btn modalShowConfirm-no" @click="cancelCancel">
            No, volver
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Proveedores -->
    <div class="modal-overlay" v-if="showProveedores">
      <div class="modal-content">
        <button class="modal-close-x" @click="closeShowProveedores">✕</button>
        <h2>Proveedores</h2>
        <table class="table">
          <thead>
            <tr>
              <th>No.Pro</th>
              <th>Proveedor</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(proveedor_actual, index) in proveedores_nombre"
              :key="index"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ proveedor_actual?.nombre || proveedor_actual }}</td>
            </tr>
          </tbody>
        </table>
        <div class="modal-actions">
          <button class="btn" @click="closeShowProveedores">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import solicompras from "../../services/solicompras";
import { setPageTitle } from "@/components/pageMetadata";
const { getSocket } = require('@/services/socket');
import ModalLoading from "@/components/ModalLoading.vue";
import { notis } from "../../services/notificaciones.js";

export default {
  name: "ComprasView",

  components: {
    ModalLoading,
  },

  data() {
    return {
      titulo: "Registro de Compras",
      addQuery: "",
      searchQuery: "",
      addQuantity: "",
      addQuantityPackage: "",
      payModal: false,
      subtotal: "",
      total: "",
      referenciaPago: "",
      confirmModal: false,
      showConfirmModal: false,
      showProveedores: false,
      addtotalPrice: "",
      articulos_cant: "",
      isEditing: false,
      productos: [],
      productosLista: [],
      proveedores_nombre: [],
      loading: false,
      error: null,
      isLoading: false,
      // Nuevos campos fiscales
      cai: "",
      numeroFactura: "",
      tipoCompra: "gravado",
      descuento: 0,
      rtnProveedor: "",
      // Modalidad de pago
      modalidadPago: "contado",
      diasCredito: 30,
    };
  },

  computed: {
    productoSeleccionado() {
      if (!this.addQuery) return null;
      return this.productos.find(p => p.codigo_producto === this.addQuery) || null;
    },

    unidadCompraLabel() {
      const p = this.productoSeleccionado;
      if (!p) return '';
      return p.unidad_compra || '';
    },

    factorConversionInfo() {
      const p = this.productoSeleccionado;
      if (!p || !p.unidad_compra || !p.factor_conversion || Number(p.factor_conversion) === 1) return '';
      return `1 ${p.unidad_compra} = ${p.factor_conversion} unid. en stock`;
    },

    calcularTotal() {
      return this.productosLista.reduce(
        (total, p) => total + p.total_compra,
        0
      );
    },

    calcularSubtotal() {
      const totalProductos = this.calcularTotal;
      const descuentoAplicado = Number(this.descuento) || 0;
      return totalProductos - descuentoAplicado;
    },

    calcularImpuesto15() {
      if (this.tipoCompra === "gravado") {
        return this.calcularSubtotal * 0.15;
      }
      return 0;
    },

    calcularGravado15() {
      if (this.tipoCompra === "gravado") {
        return this.calcularSubtotal;
      }
      return 0;
    },

    calcularExento() {
      if (this.tipoCompra === "exento") {
        return this.calcularSubtotal;
      }
      return 0;
    },

    calcularTotalFinal() {
      return this.calcularSubtotal + this.calcularImpuesto15;
    },
  },

  methods: {
    async handleCodigoInput() {
      if (this.addQuery) {
        const productoEncontrado = this.productos.find(
          (p) => p.codigo_producto === this.addQuery
        );
        if (productoEncontrado) {
          this.searchQuery = productoEncontrado.nombre;
        } else {
          this.searchQuery = "";
        }
      } else {
        this.searchQuery = "";
      }
    },

    async handleSearchInput() {
      if (this.searchQuery) {
        const productoEncontrado = this.productos.find(
          (p) => p.nombre === this.searchQuery
        );
        if (productoEncontrado) {
          this.addQuery = productoEncontrado.codigo_producto;
        } else {
          this.addQuery = "";
        }
      } else {
        this.addQuery = "";
      }
    },

    async cargarProductos() {
      this.isLoading = true;
      try {
        const token = localStorage.getItem("auth");
        if (!token) {
          this.$router.push("/login");
          return;
        }

        const productos = await solicompras.fetchRegistros("/compras/productos");
        this.productos = productos || [];
      } catch (error) {
        if (error.message.includes("No hay token")) {
          this.$router.push("/login");
          return;
        }
        notis("error", "Error al cargar la lista de productos");
      } finally {
        this.isLoading = false;
      }
    },

    validarDatos() {
      if (!this.addQuery || !this.addtotalPrice) {
        throw new Error("Por favor complete los campos requeridos");
      }

      if (
        this.addQuantity &&
        (isNaN(this.addQuantity) || this.addQuantity <= 0)
      ) {
        throw new Error("La cantidad debe ser un número mayor a 0");
      }

      if (
        this.addtotalPrice &&
        (isNaN(this.addtotalPrice) || this.addtotalPrice <= 0)
      ) {
        throw new Error("El precio debe ser un número mayor a 0");
      }

      if (
        this.addQuantityPackage &&
        (isNaN(this.addQuantityPackage) || this.addQuantityPackage <= 0)
      ) {
        throw new Error("La cantidad de paquetes debe ser un número mayor a 0");
      }
    },

    async agregarProducto() {
      this.isLoading = true;
      try {
        this.validarDatos();

        // Guardar todos los valores actuales antes de limpiar
        const referenciaActual = this.referenciaPago;
        const caiActual = this.cai;
        const numeroFacturaActual = this.numeroFactura;
        const tipoCompraActual = this.tipoCompra;
        const descuentoActual = this.descuento;

        const cantidad = this.addQuantity || "1";
        const cantidadPaquetes = this.addQuantityPackage || "1";
        const precioUnitario = this.addtotalPrice || "0";

        const productoExistente = this.productos.find(
          (p) => p.codigo_producto === this.addQuery
        );

        if (!productoExistente) {
          throw new Error("Producto no encontrado");
        }

        const totalCompra = Number(precioUnitario) * Number(cantidadPaquetes);

        const productoEnLista = this.productosLista.find(
          (p) => p.codigo === this.addQuery
        );

        if (!this.isEditing) {
          if (productoEnLista) {
            productoEnLista.cantidad = Number(cantidad);
            productoEnLista.paquetes = Number(cantidadPaquetes);
            productoEnLista.total_compra = totalCompra;
          } else {
            this.productosLista.push({
              codigo: productoExistente.codigo_producto,
              nombre: productoExistente.nombre,
              cantidad: Number(cantidad),
              paquetes: Number(cantidadPaquetes),
              proveedor: productoExistente.proveedor,
              total_compra: totalCompra,
            });
          }
        } else {
          productoEnLista.cantidad = Number(cantidad);
          productoEnLista.paquetes = Number(cantidadPaquetes);
          productoEnLista.total_compra = totalCompra;
          this.isEditing = false;
        }

        this.reiniciarInputs();

        // Restaurar todos los valores fiscales
        this.$nextTick(() => {
          this.referenciaPago = referenciaActual;
          this.cai = caiActual;
          this.numeroFactura = numeroFacturaActual;
          this.tipoCompra = tipoCompraActual;
          this.descuento = descuentoActual;
        });

        this.$refs.codigo.focus();
      } catch (error) {
        notis("error", error.message);
      } finally {
        this.isLoading = false;
      }
    },

    isEditingTrue(index) {
      const producto = this.productosLista[index];
      if (producto) {
        this.isEditing = true;
        this.addQuantity = producto.cantidad.toString();
        this.addQuery = producto.codigo;
        this.addtotalPrice = (producto.total_compra / producto.paquetes).toString();
        this.addQuantityPackage = producto.paquetes.toString();
        this.searchQuery = producto.nombre;
      }
    },

    deleteProducto(index) {
      this.productosLista.splice(index, 1);
    },

    reiniciarInputs() {
      this.addQuery = "";
      this.searchQuery = "";
      this.addQuantity = "";
      this.addtotalPrice = "";
      this.addQuantityPackage = "";
      this.isEditing = false;
    },

    limpiarTodo() {
      this.addQuery = "";
      this.searchQuery = "";
      this.addQuantity = "";
      this.addtotalPrice = "";
      this.addQuantityPackage = "";
      this.referenciaPago = "";
      this.cai = "";
      this.numeroFactura = "";
      this.tipoCompra = "gravado";
      this.descuento = 0;
      this.modalidadPago = "contado";
      this.diasCredito = 30;
      this.isEditing = false;
    },

    async confirmPayment() {
      // Validar campos obligatorios
      if (!this.referenciaPago) {
        notis("info", "Por favor ingrese una referencia de compra");
        return;
      }

      if (!this.numeroFactura) {
        notis("info", "Por favor ingrese el número de factura");
        return;
      }

      if (!this.cai) {
        notis("info", "Por favor ingrese el CAI");
        return;
      }

      this.isLoading = true;
      try {
        const datosCompra = {
          productosLista: this.productosLista,
          total: this.calcularTotalFinal,
          referenciaPago: this.referenciaPago.trim(),
          cai: this.cai.trim(),
          numeroFactura: this.numeroFactura.trim(),
          tipoCompra: this.tipoCompra,
          descuento: Number(this.descuento) || 0,
          gravado_15: this.calcularGravado15,
          exento: this.calcularExento,
          subtotal: this.calcularSubtotal,
          impuesto_15: this.calcularImpuesto15,
          modalidad_pago: this.modalidadPago,
          dias_credito: this.modalidadPago === 'credito' ? Number(this.diasCredito) || 30 : null,
        };

        this.payModal = false;

        await solicompras.registrarCompra(datosCompra);

        this.productosLista = [];
        this.limpiarTodo();
        notis("success", "Compra realizada correctamente");
      } catch (error) {
        notis("error", error.message);
      } finally {
        this.isLoading = false;
      }
    },

    payModalOpen() {
      if (this.productosLista.length > 0) {
        this.articulos_cant = this.productosLista.length;
        this.total = this.calcularTotalFinal;
        this.payModal = true;
      } else {
        notis("info", "No hay productos en la lista");
      }
    },

    cancelPayment() {
      this.payModal = false;
    },

    confirmPaymentClose() {
      this.confirmModal = false;
      this.payModal = false;
      this.reiniciarInputs();
      this.limpiarTodo();
      this.$nextTick(() => {
        this.$refs.codigo.focus();
      });
    },

    listaProveedores() {
      this.proveedores_nombre = [
        ...new Set(this.productosLista.map((p) => p.proveedor)),
      ];
      this.showProveedores = true;
      this.payModal = false;
    },

    closeShowProveedores() {
      this.showProveedores = false;
      this.payModal = true;
    },

    cancelarCompra() {
      if (this.productosLista.length > 0) {
        this.showConfirmModal = true;
      }
    },

    confirmCancel() {
      this.productosLista = [];
      this.showConfirmModal = false;
      this.limpiarTodo();
      this.$refs.codigo.focus();
    },

    cancelCancel() {
      this.showConfirmModal = false;
    },

    pushEsc(event) {
      if (event.key === "Esc" || event.key === "Escape") {
        if (this.isEditing) {
          this.isEditing = false;
          this.reiniciarInputs();
          return;
        }
        this.cancelarCompra();
      }
    },

    pushDelete(event) {
      const target = event.target;
      const isInputField =
        target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.isContentEditable;

      if (
        !isInputField &&
        event.key === "Backspace" &&
        this.productosLista.length > 0
      ) {
        this.productosLista.pop();
      }
    },

    pushF12(event) {
      if (event.key === "F12") {
        event.preventDefault();
        this.payModalOpen();
      }
    },

    changeFavicon(iconPath) {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "icon";
      link.href = iconPath;
      document.getElementsByTagName("head")[0].appendChild(link);
    },

    async guardarCompraTemporal() {
      if (this.productosLista.length === 0) {
        notis("info", "No hay productos para guardar");
        return;
      }

      this.isLoading = true;
      try {
        await solicompras.guardarCompraTemp({
          productosLista: this.productosLista,
          total: this.calcularTotalFinal,
        });
        notis("success", "Compra guardada temporalmente");
      } catch (error) {
        notis("error", error.message);
      } finally {
        this.isLoading = false;
      }
    },

    async recuperarCompraTemporal() {
      this.isLoading = true;
      try {
        const compraTemp = await solicompras.recuperarCompraTemp();
        if (compraTemp && compraTemp.productosLista) {
          this.productosLista = compraTemp.productosLista;
          notis("success", "Compra recuperada exitosamente");
        }
      } catch (error) {
        notis("error", error.message);
      } finally {
        this.isLoading = false;
      }
    },
  },

  async created() {
    await this.cargarProductos();
  },

  mounted() {
    window.addEventListener("keydown", this.pushDelete);
    window.addEventListener("keydown", this.pushEsc);
    window.addEventListener("keydown", this.pushF12);
    this.$refs.codigo.focus();
    setPageTitle("Crear Compras");
    const _s = getSocket();
    if (_s) {
      this._wsRefresh = () => this.cargarProductos();
      _s.on('compras:refresh', this._wsRefresh);
      _s.on('productos:refresh', this._wsRefresh);
    }
  },

  beforeUnmount() {
    window.removeEventListener("keydown", this.pushDelete);
    window.removeEventListener("keydown", this.pushEsc);
    window.removeEventListener("keydown", this.pushF12);
    const _s = getSocket();
    if (_s && this._wsRefresh) {
      _s.off('compras:refresh', this._wsRefresh);
      _s.off('productos:refresh', this._wsRefresh);
    }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

* {
  font-family: "Montserrat", sans-serif;
  box-sizing: border-box;
}

/* Layout Principal */
.wrapper {
  padding: 1.5rem;
  background-color: #f8f9fa;
  min-height: calc(100vh - 60px);
}

.main-container {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.purchase-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-section {
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 1.25rem;
  border: 1px solid #e9ecef;
}

/* Distribución de secciones */
.search-section {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  gap: 1.5rem;
  align-items: start;
}

.fiscal-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  align-items: end;
}

.quantities-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  align-items: end;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-label {
  font-weight: 600;
  color: #344767;
  font-size: 0.875rem;
}
.unidad-badge {
  display: inline-block;
  background: #e8f4ff;
  color: #0066cc;
  border-radius: 4px;
  padding: 0 5px;
  font-size: 0.75rem;
  font-weight: 700;
  margin-left: 4px;
}
.factor-hint {
  font-weight: 400;
  font-size: 0.75rem;
  color: #888;
}

.form-input {
  padding: 0.625rem;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 0.875rem;
  transition: all 0.2s;
  height: 42px;
}

.form-input:focus {
  border-color: #3b82f6;
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

select.form-input {
  cursor: pointer;
}

.button-group {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.btn-primary {
  background-color: #3b82f6;
  color: white;
  padding: 0.625rem 1.25rem;
  border-radius: 4px;
  border: none;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 100%;
  height: 42px;
}

.btn-primary:hover {
  background-color: #2563eb;
}

/* Resumen Fiscal */
.fiscal-summary {
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 1.25rem;
  border: 1px solid #e9ecef;
  margin-top: 1rem;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e9ecef;
}

.summary-row:last-child {
  border-bottom: none;
}

.total-row {
  font-weight: 700;
  font-size: 1.1rem;
  color: #344767;
  margin-top: 0.5rem;
  padding-top: 1rem;
  border-top: 2px solid #344767;
}

.summary-label {
  color: #6c757d;
  font-weight: 500;
}

.summary-value {
  color: #344767;
  font-weight: 600;
}

/* Responsive */
@media (max-width: 1024px) {
  .search-section {
    grid-template-columns: 1fr 1fr;
  }

  .fiscal-section,
  .quantities-section {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .search-section,
  .fiscal-section,
  .quantities-section {
    grid-template-columns: 1fr;
  }

  .form-section {
    padding: 1rem;
  }
}

.footer-section {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e9ecef;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.action-group {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.shortcut-badge {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #6c757d;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  text-transform: uppercase;
}

.btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  border-radius: 6px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn i {
  font-size: 1.1rem;
}

.btn-cancel {
  background-color: #fff;
  color: #dc3545;
  border: 1px solid #dc3545;
}

.btn-cancel:hover {
  background-color: #dc3545;
  color: #fff;
}

.btn-process {
  background-color: #198754;
  color: #fff;
  min-width: 160px;
}

.btn-process:hover {
  background-color: #146c43;
}

.process-group {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.total-container {
  background-color: #f8f9fa;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  min-width: 200px;
}

.total-label {
  display: block;
  color: #6c757d;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.total-amount {
  color: #344767;
  font-size: 1.75rem;
  font-weight: 700;
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.currency {
  color: #6c757d;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Responsive Footer */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 1.5rem;
  }

  .action-group {
    width: 100%;
    justify-content: center;
  }

  .total-container {
    width: 100%;
    text-align: center;
  }

  .total-amount {
    justify-content: center;
  }
}

/* Tabla */
.table-container {
  width: 100%;
  border: 1px solid #1a1a1a;
  border-radius: 4px;
  margin-top: 16px;
  height: auto;
  max-height: 480px;
  overflow-x: auto;
  overflow-y: auto;
}

.table {
  width: 100%;
  min-width: 800px;
  border-collapse: separate;
  border-spacing: 0;
}

.table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}

.table th,
.table td {
  padding: 8px;
  border: 1px solid #ddd;
  text-align: center;
}

.table thead th {
  background-color: #e7e4e4;
  text-align: center;
  border-bottom: 1px solid #ddd;
}

.table thead th:first-child {
  border-top-left-radius: 10px;
}

.table thead th:last-child {
  border-top-right-radius: 10px;
}

.table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

.table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

.btn-icon {
  background: transparent;
  border: none;
  padding: 5px;
  margin: 0 2px;
  font-size: 22px;
  cursor: pointer;
}

.text-danger {
  color: #dc3545;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-actions {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}

/* Botones Modal */
.modalShowConfirm-Si,
.cancelar,
.close-btn {
  background-color: #dc3545;
  z-index: 1000;
}

.modalShowConfirm-no,
.confirmar-pago {
  background-color: #4caf50;
  z-index: 1000;
}

.modalShowConfirm-Si:hover,
.cancelar:hover,
.close-btn:hover {
  background-color: #bd0d1f;
}

.modalShowConfirm-no:hover,
.confirmar-pago:hover {
  background-color: #45a049;
}

/* Scrollbar personalizado */
.table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: #c09d62;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #a38655;
}

/* Estilo para los div-modal-resumen */
.div-modal-resumen {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.div-modal-resumen label {
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: bold;
  color: #000;
}

.div-modal-resumen input {
  padding: 5px 8px;
  width: 100%;
  font-size: 14px;
  min-height: 28px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

/* =======================================================
  Modo Oscuro
======================================================= */
.dark .wrapper {
  background-color: #1a1a1a;
  color: #e0e0e0;
}

.dark .main-container {
  background-color: #242424;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.dark .form-section {
  background-color: #2a2a2a;
  border-color: #333333;
}

.dark .form-label {
  color: #e0e0e0;
}
.dark .unidad-badge {
  background: #1a3a5c;
  color: #7eb8f7;
}

.dark .form-input {
  background-color: #333333;
  border-color: #404040;
  color: #ffffff;
}

.dark .form-input::placeholder {
  color: #666666;
}

.dark .form-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

.dark .fiscal-summary {
  background-color: #2a2a2a;
  border-color: #333333;
}

.dark .summary-row {
  border-bottom-color: #333333;
}

.dark .total-row {
  border-top-color: #e0e0e0;
  color: #ffffff;
}

.dark .summary-label {
  color: #b0b0b0;
}

.dark .summary-value {
  color: #ffffff;
}

.dark .table-container {
  border-color: #1a1a1a;
  background-color: #242424;
}

.dark .table thead {
  background-color: #1a1a1a;
}

.dark .table th {
  background-color: #1a1a1a;
  color: #e0e0e0;
  border-bottom: 1px solid #151515;
  padding: 12px 16px;
  font-weight: 600;
}

.dark .table td {
  background-color: #242424;
  color: #e0e0e0;
  border-bottom: 1px solid #151515;
  padding: 12px 16px;
}

.dark .table tr:hover td {
  background-color: #2a2a2a;
}

.dark .table thead th:first-child {
  border-top-left-radius: 4px;
}

.dark .table thead th:last-child {
  border-top-right-radius: 4px;
}

.dark .table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 4px;
}

.dark .table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 4px;
}

.dark .table td.actions-cell {
  background-color: #242424;
}

.dark .table tr:hover td.actions-cell {
  background-color: #2a2a2a;
}

.dark .footer-section {
  border-top-color: #333333;
}

.dark .shortcut-badge {
  background-color: #333333;
  border-color: #404040;
  color: #b0b0b0;
}

.dark .btn-cancel {
  background-color: #2a2a2a;
  color: #ff4d4d;
  border-color: #ff4d4d;
}

.dark .btn-cancel:hover {
  background-color: #ff4d4d;
  color: #ffffff;
}

.dark .btn-process {
  background-color: #198754;
}

.dark .btn-process:hover {
  background-color: #146c43;
}

.dark .total-container {
  background-color: #2a2a2a;
  border-color: #333333;
}

.dark .total-label {
  color: #b0b0b0;
}

.dark .total-amount {
  color: #ffffff;
}

.dark .currency {
  color: #b0b0b0;
}

.dark .modal-content {
  background-color: #242424;
  color: #e0e0e0;
}

.dark .modal-overlay {
  background: rgba(0, 0, 0, 0.7);
}

.dark input:-webkit-autofill,
.dark input:-webkit-autofill:hover,
.dark input:-webkit-autofill:focus {
  -webkit-text-fill-color: #ffffff;
  -webkit-box-shadow: 0 0 0px 1000px #333333 inset;
  transition: background-color 5000s ease-in-out 0s;
}

.dark ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.dark ::-webkit-scrollbar-track {
  background: #2a2a2a;
  border-radius: 4px;
}

.dark ::-webkit-scrollbar-thumb {
  background: #4a4a4a;
  border-radius: 4px;
}

.dark ::-webkit-scrollbar-thumb:hover {
  background: #555555;
}

.dark .btn-icon {
  color: #ff4d4d;
}

.dark .btn-icon:hover {
  color: #ff6666;
}

.dark .form-input:disabled {
  background-color: #2a2a2a;
  color: #666666;
  border-color: #333333;
}

.dark .div-modal-resumen label {
  color: #fff;
}

.dark .div-modal-resumen input {
  background-color: #383838;
  border-color: #404040;
  color: #fff;
}

.dark .table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.dark .table-container::-webkit-scrollbar-track {
  background: #1a1a1a;
}

.dark .table-container::-webkit-scrollbar-thumb {
  background: #333333;
  border-radius: 4px;
}

.dark .table-container::-webkit-scrollbar-thumb:hover {
  background: #404040;
}

/* Media Queries Adicionales */
@media screen and (max-width: 768px) {
  .wrapper {
    padding: 8px;
  }

  .modal-content {
    width: 95%;
  }
}

@media screen and (max-width: 480px) {
  .wrapper {
    padding: 8px;
  }

  .table th,
  .table td {
    padding: 6px;
    font-size: 14px;
  }

  .modal-content {
    padding: 15px;
  }
}
</style>